import { Container, Overline } from "@/components/Sections";
import { Reveal } from "@/components/Reveal";

const P = (name, file, dark = false) => ({ name, src: `/partners/${file}`, dark });

const GROUPS = [
  { title: "Piattaforme e portali", items: [
    P("Macingo", "macingo.svg"), P("Spedingo", "spedingo_fav.png"), P("Bikerface", "bikerface.svg", true),
    P("Shiply", "shiply.svg", true), P("AnyVan", "anyvan.svg", true), P("ProntoPro", "prontopro.png", true), P("Ti Richiamo", "tirichiamo.png"),
    P("Fammi Spazio", "fammispazio.svg", true), P("Vai Sicuro", "vaisicuro.png"), P("Ernesto", "ernesto.png"), P("Stripe", "stripe.svg"),
  ] },
  { title: "Corrieri e logistica", items: [
    P("BRT (DPD - Bartolini)", "brt.png"), P("SDA", "sda.png"), P("Poste Italiane", "poste.png"), P("Amazon", "amazon.svg"),
    P("DHL", "dhl.svg"), P("GLS", "gls.svg"), P("UPS", "ups.svg"), P("FedEx", "fedex.svg"),
  ] },
  { title: "Moto: brand e concessionari", items: [
    P("Ducati Firenze", "ducati.svg"), P("Harley-Davidson Bari", "harley.svg"), P("Triumph Italia", "triumph.svg", true),
    P("BMW Motorrad Italia", "bmw.svg"), P("Aprilia", "aprilia.svg"), P("Vespa", "vespa.svg"), P("Honda", "honda.svg"),
    P("Yamaha", "yamaha.svg"), P("KTM", "ktm.svg"), P("Kymco", "kymco.svg"), P("Lambretta", "lambretta.png"),
    P("Moto Morini", "morini.png"), P("Piaggio", "piaggio.svg"), P("Peugeot", "peugeot.svg"), P("SYM", "sym.svg"), P("Suzuki", "suzuki.svg"),
  ] },
  { title: "Arredo, imballaggi e tecnologia", items: [
    P("EMU - Interni Milano", "emu.png"), P("Orsini Imballaggi", "orsini-logo.svg"), P("PAJ GPS", "paj.svg", true),
    P("Lenovo", "lenovo.svg"), P("Apple", "apple.svg"), P("Tecnomat", "tecnomat.svg"), P("Leroy Merlin", "leroy.svg"), P("Imballaggi Point", "imballaggipoint.png"),
  ] },
];

const Logo = ({ p }) => (
  <div className={`group h-full rounded-2xl border p-5 flex flex-col items-center justify-between gap-4 transition-shadow hover:shadow-[0_20px_40px_rgb(0,0,0,0.06)] ${p.dark ? "bg-[#121212] border-[#121212]" : "bg-white border-zinc-100"}`}
    data-testid={`partner-${p.name.split(" ")[0].toLowerCase()}`}>
    <div className="h-16 w-full flex items-center justify-center">
      <img src={p.src} alt={`Logo ${p.name}`} loading="lazy" className="max-h-14 max-w-[85%] object-contain transition-transform duration-300 group-hover:scale-105" />
    </div>
    <span className={`text-xs font-semibold text-center ${p.dark ? "text-zinc-300" : "text-zinc-500"}`}>{p.name}</span>
  </div>
);

export const Partners = () => (
  <section className="py-24 md:py-32 bg-[#F4F4F5]" data-testid="partners-section">
    <Container>
      <Reveal className="max-w-2xl mb-14">
        <Overline>Partner e collaborazioni</Overline>
        <h2 className="font-head text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-3 leading-[1.1]">Lavoriamo con chi muove l'Italia.</h2>
        <p className="text-zinc-500 mt-5 text-lg leading-relaxed">Piattaforme, corrieri, brand e aziende con cui AXAL collabora.</p>
      </Reveal>
      <div className="space-y-12">
        {GROUPS.map((g) => (
          <div key={g.title}>
            <h3 className="text-[11px] uppercase tracking-[0.2em] font-bold text-zinc-500 mb-5">{g.title}</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
              {g.items.map((p, i) => (
                <Reveal key={p.name} delay={(i % 7) * 0.05}><Logo p={p} /></Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Container>
  </section>
);
